// extracted by mini-css-extract-plugin
module.exports = {"totalPrice":"styles_totalPrice__cacg5"};